export default __webpack_public_path__ + "static/media/register-artwork-3.1fc893ca.svg";